import { BagsPassangerInt } from "@app/interfaces/micro/bags.interface";
import { GROUP_CODE, StatusBag, TypeBagsWeight } from "@app/enums";
import { getUniqueId } from "@app/utils";

type BagPassangerModelProperties = Omit<BagsPassangerInt, keyof Object>;

export class BagPassangerModel implements BagsPassangerInt {
  // Properties with default values
  carryOn: any = null;
  commercialName: string = '';
  currency: any = { code: '', value: 0 };
  emdConsummedAtIssuance: string = '';
  emdType: string = '';
  extraBags: any = null;
  extraBags20KG: any = null;
  extraWeight: any = null;
  extraWeightType: string = '';
  groupCode: GROUP_CODE = GROUP_CODE.BAGS;
  id: string = getUniqueId(4);
  idBag: string = '';
  isExtraWeight: boolean = false;
  legCode: string = '';
  order: number = 0;
  owningCarrierCode: string = '';
  paid: boolean = false;
  quantity: number = 1;
  redeemed: boolean = false;
  rficCode: string = '';
  rficSubcode: string = '08K';
  selected: boolean = true;
  ssrCode: string = '';
  type: string = '';
  typeBagWeight: TypeBagsWeight = TypeBagsWeight._25KG;
  used: boolean = false;
  weight: string = '0';
  weightBag: number = 0;
  weightDifference: number = 0;
  code?: string = '';
  currencyPerLeg: any[];
  emd?: string = '';
  isRedemptionCobrand?: boolean = false;
  isRedemptionFF?: boolean = false;
  isRedemptionTier?: boolean = false;
  nameDescription?: string = '';
  passengerId?: string = '';
  reredemptionCobrandBy?: string;
  segmentCode?: string;
  status: StatusBag = StatusBag.INCLUDE;
  wuth?: string;
  isPreLoad?: boolean;

  constructor(properties?: Partial<BagPassangerModelProperties>) {
    if (properties) {
      Object.assign(this, properties);
    }
    return this;
  }
  

  // Builder pattern implementation
  static builder(): BagPassangerModelBuilder {
    return new BagPassangerModelBuilder();
  }

  // Create from existing object
  static from(properties: Partial<BagPassangerModelProperties>): BagPassangerModel {
    return new BagPassangerModel(properties);
  }
}

// Builder class
class BagPassangerModelBuilder {
  private properties: Partial<BagPassangerModel> = {};

  withCarryOn(carryOn: any): this {
    this.properties.carryOn = carryOn;
    return this;
  }

  withCommercialName(commercialName: string): this {
    this.properties.commercialName = commercialName;
    return this;
  }

  withCurrency(currency: any): this {
    this.properties.currency = currency;
    return this;
  }

  withEmdConsummedAtIssuance(emdConsummedAtIssuance: string): this {
    this.properties.emdConsummedAtIssuance = emdConsummedAtIssuance;
    return this;
  }

  withEmdType(emdType: string): this {
    this.properties.emdType = emdType;
    return this;
  }

  withExtraBags(extraBags: any): this {
    this.properties.extraBags = extraBags;
    return this;
  }

  withExtraBags20KG(extraBags20KG: any): this {
    this.properties.extraBags20KG = extraBags20KG;
    return this;
  }

  withExtraWeight(extraWeight: any): this {
    this.properties.extraWeight = extraWeight;
    return this;
  }

  withExtraWeightType(extraWeightType: string): this {
    this.properties.extraWeightType = extraWeightType;
    return this;
  }

  withGroupCode(groupCode: GROUP_CODE): this {
    this.properties.groupCode = groupCode;
    return this;
  }

  withId(id: string): this {
    this.properties.id = id;
    return this;
  }

  withIdBag(idBag: string): this {
    this.properties.idBag = idBag;
    return this;
  }

  withIsExtraWeight(isExtraWeight: boolean): this {
    this.properties.isExtraWeight = isExtraWeight;
    return this;
  }

  withLegCode(legCode: string): this {
    this.properties.legCode = legCode;
    return this;
  }

  withOrder(order: number): this {
    this.properties.order = order;
    return this;
  }

  withOwningCarrierCode(owningCarrierCode: string): this {
    this.properties.owningCarrierCode = owningCarrierCode;
    return this;
  }

  withPaid(paid: boolean): this {
    this.properties.paid = paid;
    return this;
  }

  withQuantity(quantity: number): this {
    this.properties.quantity = quantity;
    return this;
  }

  withRedeemed(redeemed: boolean): this {
    this.properties.redeemed = redeemed;
    return this;
  }

  withRficCode(rficCode: string): this {
    this.properties.rficCode = rficCode;
    return this;
  }

  withRficSubcode(rficSubcode: string): this {
    this.properties.rficSubcode = rficSubcode;
    return this;
  }

  withSelected(selected: boolean): this {
    this.properties.selected = selected;
    return this;
  }

  withSsrCode(ssrCode: string): this {
    this.properties.ssrCode = ssrCode;
    return this;
  }

  withStatus(status: StatusBag): this {
    this.properties.status = status;
    return this;
  }

  withWuth(wuth: string): this {
    this.properties.wuth = wuth;
    return this;
  }

  withType(type: string): this {
    this.properties.type = type;
    return this;
  }

  withTypeBagWeight(typeBagWeight: TypeBagsWeight): this {
    this.properties.typeBagWeight = typeBagWeight;
    return this;
  }

  withUsed(used: boolean): this {
    this.properties.used = used;
    return this;
  }

  withWeight(weight: string): this {
    this.properties.weight = weight;
    return this;
  }

  withWeightBag(weightBag: number): this {
    this.properties.weightBag = weightBag;
    return this;
  }

  withWeightDifference(weightDifference: number): this {
    this.properties.weightDifference = weightDifference;
    return this;
  }
  withIsPreLoad(isPreLoad: boolean): this {
    this.properties.isPreLoad = isPreLoad;
    return this;
  }

  build(): BagPassangerModel {
    return new BagPassangerModel(this.properties);
  }
}
